/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Quick Schedule form field constants
 *
 * @file quickScheduleFormConstants.js
 * @author Anuja Gaikwad
 * @since 2.0.3
 */

export const QUICK_SCHEDULE_FORM_DATE_FIELD_CLASS = 'quick-schedule-form-date-field';
export const QUICK_SCHEDULE_FORM_TIME_FIELD_CLASS = 'quick-schedule-form-time-field';
export const QUICK_SCHEDULE_FORM_TIMEZONE_FIELD_CLASS = 'quick-schedule-form-timezone-field';
export const QUICK_SCHEDULE_FORM_DAYS_FIELD_CLASS = 'quick-schedule-form-days-field';

export const quickScheduleFormFieldLabelStyles = (mixins) => ({
  fontSize: mixins.fontSize16,
  fontWeight: mixins.fontWeight500,
  fontFamily: mixins.fontFamilyPlusSans,
  color: mixins.color_text_primary,
  lineHeight: '24px',
  paddingBottom: 4
});
